/**
 * Icon Grid block styles.
 */
import './style.scss';
